// Shown on every public route while the site is taken down
// (後台 → 網站設定 → 網站上線狀態). The admin backend (/admin) is unaffected,
// so content can be maintained and uploaded before the site goes live.

import SEO from "@/components/SEO";
import Icon from "@/components/feature/Icon";
import { maintenanceCopy, useSiteSettings } from "@/lib/siteSettings";

export default function MaintenancePage() {
  const { settings } = useSiteSettings();
  const { title, message } = maintenanceCopy(settings.maintenance);
  const { contact } = settings;

  return (
    <>
      <SEO title={`${title}｜TAIAA 台灣 AI 應用推廣協會`} description={message} noindex />
      <main
        className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-navy-950 px-6 py-16 text-center"
        data-testid="maintenance-page"
      >
        <div className="pointer-events-none absolute inset-0 opacity-[0.06]">
          <div
            className="h-full w-full animate-grid-move"
            style={{
              backgroundImage:
                "linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)",
              backgroundSize: "80px 80px",
            }}
          />
        </div>
        <div className="absolute left-[10%] top-[15%] h-64 w-64 rounded-full bg-white/[0.03] blur-3xl animate-float-1" />
        <div className="absolute bottom-[20%] right-[12%] h-72 w-72 rounded-full bg-silver-300/[0.03] blur-3xl animate-float-2" />

        <div className="relative z-10 max-w-2xl">
          <div className="mx-auto mb-8 flex h-16 w-16 items-center justify-center rounded-2xl border border-white/20 bg-white/10 backdrop-blur-sm">
            <span className="text-2xl font-bold text-white">T</span>
          </div>
          <p className="mb-4 text-sm font-medium uppercase tracking-[0.25em] text-silver-400">TAIAA · 台灣 AI 應用推廣協會</p>
          <h1 className="mb-6 font-serif text-4xl font-semibold leading-tight text-white md:text-5xl">{title}</h1>
          <p className="mx-auto max-w-xl whitespace-pre-line text-base leading-relaxed text-silver-300 md:text-lg">{message}</p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <a
              href={`mailto:${contact.email}`}
              className="inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-medium text-navy-950 transition-colors hover:bg-silver-100"
            >
              <Icon className="ri-mail-line" />
              {contact.email}
            </a>
            {contact.community_url && (
              <a
                href={contact.community_url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full border border-white/30 px-7 py-3.5 text-sm font-medium text-white transition-colors hover:bg-white/10"
              >
                <Icon className="ri-chat-1-fill" />
                LINE 社群
              </a>
            )}
          </div>
        </div>

        <footer className="relative z-10 mt-16 text-xs text-silver-500">
          © {new Date().getFullYear()} {contact.legal_name}
          {contact.registration ? ` · ${contact.registration}` : ""}
        </footer>
      </main>
    </>
  );
}
